import { createSlice } from '@reduxjs/toolkit';
import {
  getCandidateRecordInfoThunk,
  getCandidateRecordListThunk,
} from './Record.thunk';
import { PersonRecord } from './Record.type';

export const personRecordSlice = createSlice({
  name: 'personRecord',
  initialState: {
    list: {
      items: [] as PersonRecord[],
      loading: true,
      pagination: {},
    },
    selected: {
      item: undefined,
      loading: false,
    },
  },
  reducers: {
    resetCandidateRecordInfoAction: (state, action) => ({
      ...state,
      selected: {
        item: undefined,
        loading: false,
      },
    }),
    resetCandidateRecordListAction: (state, action) => ({
      ...state,
      list: {
        ...state.list,
        items: [],
        loading: true,
        pagination: {},
      },
    }),
  },
  extraReducers: builder => {
    // Start Candidate Records List
    builder.addCase(getCandidateRecordListThunk.pending, (state, action) => {
      state.list = { ...state.list, loading: true };
    });
    builder.addCase(getCandidateRecordListThunk.fulfilled, (state, action) => {
      const { data, pagination: _pagination } = action.payload;
      const newData = Array.isArray(data) ? data : [];
      const pagination = {
        currentPage: _pagination.current_page,
        lastPage: _pagination.last_page,
        total: _pagination.total,
      };
      state.list = {
        ...state.list,
        pagination,
        loading: false,
        // it's 1 and not 0 because our backend start pages from 1 and not 0
        // thus, the first page is the page 1
        items: pagination.currentPage === 1
        ? [...newData]
        : [...state.list.items, ...newData],
      };
    });
    builder.addCase(getCandidateRecordListThunk.rejected, (state, action) => {
      // state.list = { ...state.list, loading: false };
    });
    // End Candidate Records List
    // Start Candidate Record Info
    builder.addCase(getCandidateRecordInfoThunk.pending, (state, action) => {
      state.selected = { ...state.selected, loading: true };
    });
    builder.addCase(getCandidateRecordInfoThunk.fulfilled, (state, action) => {
      state.selected = { item: action.payload, loading: false };
    });
    builder.addCase(getCandidateRecordInfoThunk.rejected, (state, action) => {
      // state.selected = { ...state.selected, loading: false };
    });
    // End Candidate Record Info
  },
});

export const {
  resetCandidateRecordInfoAction,
  resetCandidateRecordListAction,
} = personRecordSlice.actions;
export const getCandidateRecordsList = (state: any) => state.personRecord.list;
export const getCandidateRecordInfo = (state: any) =>
  state.personRecord.selected;

export default personRecordSlice.reducer;
